"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const BlankButton_1 = require("./BlankButton");
function ButtonComp(_a, ref) {
    var { variant = 'primary', className, disabled, size = 'large', showBackgroundColor, children } = _a, props = __rest(_a, ["variant", "className", "disabled", "size", "showBackgroundColor", "children"]);
    return ((0, jsx_runtime_1.jsx)(BlankButton_1.BlankButton, Object.assign({ ref: ref, className: (0, classnames_1.default)({
            // Adding a background color to button can be as needed bases so controlling that via a prop
            'bg-green-50 text-white': variant === 'primary' && !disabled && showBackgroundColor,
            'bg-blue-90 text-white hover:bg-blue-80 hover:text-silver-10': variant === 'secondary' && !disabled && showBackgroundColor,
            'bg-silver-90 text-white': variant === 'tertiary' && !disabled && showBackgroundColor,
            // Colors
            'hover:shadow-sm': !disabled,
            'bg-silver-10 text-silver-40': disabled,
            'bg-blue-80 text-white hover:bg-blue-90': variant === 'primary' && !disabled && !showBackgroundColor,
            'bg-white text-blue-80 border border-blue-80 hover:bg-blue-80 hover:text-white': variant === 'secondary' && !disabled && !showBackgroundColor,
            'bg-white text-silver-90 border border-silver-30 hover:bg-silver-5 hover:border-silver-50': variant === 'tertiary' && !disabled && !showBackgroundColor,
            // Size
            'h-11 px-6': size === 'large',
            'h-9 px-5': size === 'medium'
        }, className), disabled: disabled }, props, { children: children })));
}
exports.Button = (0, react_1.forwardRef)(ButtonComp);
//# sourceMappingURL=Button.js.map